import type { QuoteRestriction } from "@freightsimple/generated-dashboard-openapi-client/models/QuoteRestriction";
import { QuoteRestrictionType } from "@freightsimple/generated-dashboard-openapi-client/models/QuoteRestrictionType";
import { parseHours } from "./locationsErrorMessageForHours";

/**
 * Returns the effective pickup close time, which is the earlier of
 * the user's dock close and any carrier PICKUP_OPEN_BEFORE cutoff.
 */
export function getEffectivePickupClose(
  pickupOpenUntil: string,
  restrictions: QuoteRestriction[],
): string {
  for (const r of restrictions) {
    if (r.type === QuoteRestrictionType.PickupOpenBefore && r.time) {
      const userClose = parseHours(pickupOpenUntil);
      const carrierCutoff = parseHours(r.time);
      return userClose <= carrierCutoff ? pickupOpenUntil : r.time;
    }
  }
  return pickupOpenUntil;
}
